import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import * as actions from '../actions'
import { FORM_CEREAL_A_VOLCADORA } from '../../../config/forms'
import {
  Row,
  Col
} from 'react-bootstrap'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../config/settings'
import TablaVolcadorasConCerealAsignado from '../../Movimiento/TablasSinAsignar/volcadorasConCerealAsignado/containers/TablaVolcadorasConCerealAsignado'

class AsignacionCerealAVolcadora extends Component {
  render () {
    return (
      <>
        <h6 className='nombre-tabla-cm' >Asignación de Cereal a Volcadora</h6>
        <Row>
          <Col md={12} className='muitable-volcadoras-movimiento'>
            <TablaVolcadorasConCerealAsignado />
          </Col>
        </Row>
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <hr />
      </>
    )
  }
}

const mapStateToProps = (state) => ({

})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_CEREAL_A_VOLCADORA,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(AsignacionCerealAVolcadora))
